angular.module('gym.components').directive('waiverMembershipForm', function() {
  return {
    restrict: 'E',
    scope: {
      waiver: '=',
      currency: '='
    },
    template: require('templates/components/waivers/waiver_membership_form.html.slim'),
    controller: ["$scope", function($scope) {
      var groupMembershipPlans;
      $scope.familyMembershipStrategy = $scope.waiver.signed_waiver_form_attributes.family_membership_strategy;
      groupMembershipPlans = function() {
        var groupMemberships, plans;
        groupMemberships = $scope.waiver.signed_waiver_form_attributes.group_memberships;
        plans = $scope.waiver.signed_waiver_form_attributes.membership_plan_options;
        return _.groupBy(plans, function(plan) {
          var ref;
          if (groupMemberships) {
            return (ref = plan.category) != null ? ref.label : void 0;
          } else {
            return '';
          }
        });
      };
      $scope.signedAsFamily = $scope.waiver.signed_as === 'signed_as_adult_with_family';
      $scope.activeContacts = function() {
        return $scope.waiver.signed_waiver_contacts_attributes.filter(function(c) {
          return !c._destroy;
        });
      };
      $scope.multipleContacts = function() {
        return $scope.activeContacts().length > 1;
      };
      $scope.displayContactMemberships = function(contact, index) {
        return !$scope.signedAsFamily || $scope.multipleMemberships() || ($scope.familyMembershipStrategy === 'only_parent_pays_membership' && index === 0) || ($scope.familyMembershipStrategy === 'every_attendee_pays_membership' && $scope.signedAsFamily && index === 1);
      };
      $scope.multipleMemberships = function() {
        return $scope.signedAsFamily && $scope.familyMembershipStrategy === 'each_signee_chooses_own_membership' && $scope.activeContacts().length > 1;
      };
      $scope.onMembershipChanged = function(contact) {
        contact.requested_membership_start_date = void 0;
        if (!$scope.multipleMemberships() && $scope.activeContacts().length > 1) {
          return $scope.activeContacts().forEach(function(c) {
            if (!($scope.familyMembershipStrategy === 'every_attendee_pays_membership' && c.primary && c.attending === false)) {
              c.membership_plan_id = contact.membership_plan_id;
              return c.requested_membership_start_date = void 0;
            }
          });
        }
      };
      if ($scope.waiver.signed_waiver_form_attributes) {
        $scope.groupedMemberships = _.chain(groupMembershipPlans()).pairs().sortBy(function(item) {
          return item[0];
        }).value();
      }
      return $scope.getPlanPurchaseLimitLabel = function(membershipPlan) {
        var label, name, purchase_limit, purchases_remaining;
        name = membershipPlan.label;
        purchase_limit = membershipPlan.purchase_limit;
        purchases_remaining = membershipPlan.purchases_remaining;
        return label = purchase_limit > 0 && purchases_remaining === 0 ? "<strong>(Sold out)</strong> " : purchase_limit > 0 && purchases_remaining !== 0 ? `<strong>(${purchases_remaining} remaining)</strong> ` : void 0;
      };
    }]
  };
});
